
<div mat-dialog-title class = "mat-dialog-title">Options</div>
<mat-dialog-content>
  <button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button>
  @if (securitySymbol) {
    <div class = "nameHeader">
      Security : "{{securitySymbol}}"
    </div>
  }
  @if (viewOptionList) {
    <div class = "mat-dialog-content counter">{{viewOptionList.length}} option securities</div>
  }
  <irb-inventory-grid
    [gridOptions]="gridOptions"
    (gridReady)="onGridReady($event)"
    [style.height]="'350px'"
    [showSideBar]="false"
    [style.minHeight]="'350px'"
  ></irb-inventory-grid>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>
